/**
 * ChatSuggestions — contextual chip buttons shown when a session has no messages yet.
 */
import { Button, Space } from 'antd';

interface Props {
  suggestions: string[];
  onSelect: (text: string) => void;
}

export function ChatSuggestions({ suggestions, onSelect }: Props) {
  return (
    <div style={{ padding: '12px 16px 0' }}>
      <Space size={[6, 6]} wrap>
        {suggestions.map((s) => (
          <Button
            key={s}
            size="small"
            style={{ borderRadius: 16, fontSize: 12, height: 'auto', whiteSpace: 'normal', textAlign: 'left' }}
            onClick={() => onSelect(s)}
          >
            {s}
          </Button>
        ))}
      </Space>
    </div>
  );
}
